import { forwardRef, type Ref, type SVGProps } from "react";
const IconThumbsDownOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path fill="currentColor" d="M7 6a1 1 0 1 1-1-1 1 1 0 0 1 1 1" />
    <path
      fill="currentColor"
      d="M28.36 10.16a4.21 4.21 0 0 0-.93-4.09 2.81 2.81 0 0 0-.35-2.45C25.93 2 23.05 2 20.62 2h-.17a17 17 0 0 0-6.79 1.73 15.6 15.6 0 0 1-3.66.73V4a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h4a2 2 0 0 0 1.7-1c2 2.24 4.11 5.19 5.57 6.59a6.4 6.4 0 0 1 1.43 3.22c.26 1 .78 3.16 1.94 3.16 1.36 0 4.09-.44 4.09-4.46 0-2.31-1.31-4-1.73-5.54h5.67C28.5 20 30 19 30 17.19a3.82 3.82 0 0 0-1.11-2.68 4.44 4.44 0 0 0-.53-4.35M8 16H4V4h4zm20 1.16c0 .75-.95.84-1.34.84h-7a1 1 0 0 0-1 1.26l.34 1.26a13 13 0 0 0 .76 2 7.35 7.35 0 0 1 .9 3.05c0 1.76-.59 2.31-1.58 2.43a10 10 0 0 1-.48-1.53 8.46 8.46 0 0 0-1.87-4.1l-.07-.09-.08-.07a45 45 0 0 1-3-3.49c-1.23-1.53-2.49-3.1-3.67-4.29V6.48a15.8 15.8 0 0 0 4.55-1A15.1 15.1 0 0 1 20.5 4h.12c1.47 0 4.21 0 4.82.77a.82.82 0 0 1 .09.68l-.35 1.1.77.86a2.21 2.21 0 0 1 .5 2.16l-.3 1 .6.81a2.44 2.44 0 0 1 .3 2.4L26.54 15l.92.95a1.83 1.83 0 0 1 .54 1.21"
    />
  </svg>
);
const ForwardRef = forwardRef(IconThumbsDownOutlineSVG);
ForwardRef.displayName = "IconThumbsDownOutline";
export { ForwardRef as IconThumbsDownOutline };
